<template>
  <div class="wrapper">
    <router-link to="/tasks">待办事项</router-link>
    <br>
    <br>
    <router-link to="/balance-sheets">资产负债表</router-link>
    <br>
    <br>
    <router-link to="/profits">利润表</router-link>
    <br>
    <br>
    <router-link to="/cashflows">现金流量表</router-link>
    <br>
    <br>
    <router-link to="/contracts">合同</router-link>
    <br>
    <br>
    <router-link to="/receipt-counts">发票余额查询</router-link>
    <br>
    <br>
    <router-link to="/company-info">企业信息</router-link>
    <br>
    <br>
    <router-link to="/tax-filings">报税记录</router-link>
    <br>
    <br>
    <router-link to="/balances">科目余额表</router-link>
    <br>
    <br>
  </div>
</template>

<script>
  export default {
    name: "Home"
  }
</script>

<style scoped>

</style>